/* global $, Calendar */
/**
 *  All functions related to the search form submiting, validation and structure manipulation.
 *  The form type being used should be specified on the form initialization.
 *  Form type should be specified on the view name for best practices, ex: _search_flights_<form_type>
 *
 *  Initialization params:
 *   {
 *       form_selector : (string) jquery selector of the form,
 *       airportsearch_field_class : (string) class that should be applied on the airport autocomplete input,
 *       form_view_type : (string) search_flights view type in use, ex: _search_flights_<form_type>,
 *   }
 *
 *  Json response expected values:
 *   {result : (bool) [, feedback_message : (string)]}
 */
(function() {
    'use strict';

    window.RadioButtonChanger = function() {
        this.changeTo = function(name) {
            $('.currency-changer').prop('checked', false);
            $('input[name="' + name + '"]').prop('checked', true);
            var currency = name.split('_'); // looks like your face doesnt want to split
            // store currency as cookie as well
            document.cookie.replace('display_currency', currency[1].toLowerCase());
            $.cookie('display_currency', currency[1].toLowerCase());
        };
    };

    window.Deselect = function() {
        this.changeSelect = function(name) {
            if ($('select[name="' + name + '"]').find(':selected').index() > 0) {
                $('select[name="' + name + '"]').removeClass('deselect').addClass('selected');
            }
            else {
                $('select[name="' + name + '"]').removeClass('selected').addClass('deselect');
            }
        };
    };

    window.FlightSearch = function(params) {
        var self = this;
        this.form_selector = '';
        this.airportsearch_field_class = '';
        this.form_view_type = '';

        this.segments_to_show = '';
        this.segments_to_show_forced = false;
        this.current_trip_type = '';
        this.minimal_display = '';

        this.error_message_template = '';

        this.currency_type = '';

        this.link_airport_fields = true;

        this.Calendar = {
            calendar_class: '.search-calendar',
            start_day_limit: params.day_limit || 1
        };

        this.AirportAutocomplete = {};

        this.resetDefault = function() {
            this.form_selector = 'form[name=flight_search_form]';
            this.airportsearch_field_class = '.airport_search';
            this.form_view_type = 'home';

            this.segments_to_show = 2;
            this.min_segments_to_display_multi = 1;
            this.show_hide_effect = 'showhide';

            this.current_trip_type = 'roundtrip';
            this.minimal_display = true;

            this.error_message_template = '<div class="feedback-error">:error_message</div>';

            this.currency_type = 'CAD';
        };

        this._mergeParams = function(params) {
            // override the default params
            for (var param_name in params) {
                if (typeof this[param_name] === 'object') {
                    if (typeof params[param_name] !== 'object') {
                        continue;
                    }

                    for (var sub_param_name in params[param_name]) {
                        if (params[param_name].hasOwnProperty(sub_param_name)) {
                            this[param_name][sub_param_name] = params[param_name][sub_param_name];
                        }
                    }
                }
                else if (typeof this[param_name] !== 'undefined') {
                    this[param_name] = params[param_name];
                }
            }
        };

        this._getNumDefaultSegmentsByType = function(flight_type) {
            switch (flight_type) {
                case 'roundtrip':
                    return 2;
                case 'oneway':
                    return 1;
                case 'multi':
                    return 3;
            }
        };

        this.changeFlightTypeTab = function(flight_type, keep_input_values) {
            this.closeTripType();

            if (flight_type === 'oneway') {
                this.Calendar.resetDates();
            }

            if (flight_type !== 'roundtrip' && flight_type !== 'multi' && flight_type !== 'oneway') {
                return;
            }

            if (this.current_trip_type === flight_type) {
                return;
            }

            this.current_trip_type = flight_type;
            if (!this.segments_to_show_forced) {
                this.segments_to_show = this._getNumDefaultSegmentsByType(flight_type);
            }

            var parent = this;

            // link input fields for round trip
            parent.link_airport_fields = flight_type === 'roundtrip' ? true : false;
            //this.reInitAutocomplete();
            // move things around now
            this._reorganizeFormElements();

            // show and hide the fields
            this._showSegmentFields(keep_input_values);

            // store the flight type on a hidden field to help handle errors
            $(this.form_selector + ' [name=flight_type]').attr('value', flight_type);

            // site search form
            $(this.form_selector + ' .flight_type_button.active').removeClass('active');
            $(this.form_selector + ' .flight_type_button_' + flight_type + '').addClass('active');

            // search widget
            $(this.form_selector + ' .route-type-button.active').removeClass('active');
            $(this.form_selector + ' .route-type-button[rel=' + flight_type + ']').addClass('active');

            this.Calendar.resetMinDate();
            $(this.form_selector + ' .error').removeClass('error');
        };

        // REORGANIZE FORM ELEMENTS
        this._reorganizeFormElements = function() {
            if (this.form_view_type === 'home') {
                this._reorganizeFormElementsDefault();
            }
            else if (this.form_view_type === 'widget') {
                this._reorganizeFormElementsDefault();
            }
            else if (this.form_view_type === 'modal') {
                this._reorganizeFormElementsDefault();
            }
            else if (this.form_view_type === 'sidebar') {
                this._reorganizeFormElementsDefault();
            }
            else if (this.form_view_type === 'compact') {
                this._reorganizeFormElementsCompact();
            }
            this._linkAutofillInput();
        };

        this._reorganizeFormElementsDefault = function() {
            var seg1_date = $(this.form_selector + ' .seg1_date_wrap');
            var seg1_date_label;

            $(this.form_selector + ' .buttons-add-remove').hide();
            if (this.current_trip_type === 'roundtrip') {
                $(this.form_selector + ' .wrap_seg1').show();
                $(this.form_selector + ' .bound').show();
                $(this.form_selector + ' .multi').hide();
                $(this.form_selector + ' .oneway').hide();
                $(this.form_selector + ' .flex').show();
            }
            else {

                $(this.form_selector + ' .bound').hide();
                $(this.form_selector + ' .flex').show();
                if (this.current_trip_type === 'multi') {
                    if (this.segments_to_show !== 5) {
                        $(this.form_selector + ' .buttons-add-remove').show();
                    }
                    $(this.form_selector + ' .multi').show();
                    $(this.form_selector + ' .oneway').hide();
                    $(this.form_selector + ' .flex').hide();
                }
                else { // remove the flight number for one way
                    $(this.form_selector + ' .oneway').show();
                    $(this.form_selector + ' .multi').hide();
                }

                seg1_date_label = 'Depart';
            }

            $(this.form_selector + ' .seg1_date_wrap strong').html(seg1_date_label);
        };

        this._reorganizeFormElementsCompact = function() {
            if (this.current_trip_type !== 'roundtrip') {
                $(this.form_selector + ' .form-arrow').hide();
            }
        };

        this.multiSegmentAddRemove = function(type, keep_input_values) {
            switch (type) {
                case 'add':
                    this.segments_to_show++;
                    break;

                case 'remove':
                    this.segments_to_show--;
                    break;

                default:
                    return;
            }

            if (this.segments_to_show > 5) {
                this.segments_to_show = 5;
            }
            else if (this.segments_to_show < 1) {
                this.segments_to_show = 1;
            }

            this._showSegmentFields(keep_input_values);
            this._reorganizeFormElements();
        };

        this.singleSegmentCascadingRemove = function(unwanted_seg) // tres stuff!
        {
            // reduce segment count
            this.segments_to_show--;

            //check next
            var next_seg = unwanted_seg + 1;

            // check if there is a next node visible
            var form = $(this.form_selector);
            if (form.find('.seg' + next_seg).is(':visible')) {
                var next_field = {from: '', to: '', date: '', time: ''};
                for (var i = unwanted_seg; i < this.segments_to_show; i++) {
                    if (form.find('.seg' + i).is(':visible')) {
                        next_field.from = form.find('.seg' + (i + 1) + ' .seg_from').val();
                        next_field.to = form.find('.seg' + (i + 1) + ' .seg_to').val();
                        next_field.date = form.find('.seg' + (i + 1) + ' .seg_date').val();
                        next_field.time = form.find('.seg' + (i + 1) + ' .seg_time').val();
                        // clean values
                        form.find('.seg' + (i + 1) + ' .seg_from').val('');
                        form.find('.seg' + (i + 1) + ' .seg_to').val('');
                        form.find('.seg' + (i + 1) + ' .seg_date').val('');
                        form.find('.seg' + (i + 1) + ' .seg_time').val('');
                        // overwrite values
                        form.find('.seg' + i + ' .seg_from').val(next_field.from);
                        form.find('.seg' + i + ' .seg_to').val(next_field.to);
                        form.find('.seg' + i + ' .seg_date').val(next_field.date);
                        form.find('.seg' + i + ' .seg_time').val(next_field.time);
                    }
                }
            }
            // remove last segment, yay!

            // reorganize element
            this._showSegmentFields();
            this._reorganizeFormElements();
        };

        this.displayPassengers = function() {
            var selector = '[rel=passengers_select]';
            $(selector).css('display', $(selector).css('display') === 'block' ? 'none' : 'block');

            // set the hovering effect
            var t;
            $(selector + ', #passengers_select').hover(
                function(e) {
                    clearTimeout(t);
                },
                function(e) {
                    // IE fix
                    var $target = $(e.target);
                    if (!$target.is('option') && !$target.is('select')) {
                        t = setTimeout('$(\'' + selector + '\').hide()', 200);
                    }
                }
            );
        };

        this.displayTripType = function() {
            var selector = '[rel=triptype_select]';
            $(selector).css('display', $(selector).css('display') === 'block' ? 'none' : 'block');

            // set the hovering effect
            var t;
            $(selector + ', #triptype_select').mouseout(function() {
                t = setTimeout('$(\'' + selector + '\').hide()', 1000);
            });

            $(selector + ', #triptype_select').mouseover(function() {
                clearTimeout(t);
            });
        };

        this.closeTripType = function() {
            $('[rel=triptype_select]').hide();
            $(this.form_selector + ' .error').removeClass('error');
            $(this.form_selector + ' .error-label').remove();
        };

        this.updateNumPassengers = function() {
            var num_passengers = 0;
            $(this.form_selector)
                .find('[rel=passengers_select] select')
                .each(function() {
                    num_passengers += parseInt($(this).val());
                });

            $('#passengers_select div span').html(num_passengers + ' Passenger' + (num_passengers > 1 ? 's' : ''));
        };

        this.displaySeatClass = function() {
            var selector = '[rel=seat_class_select]';
            $(selector).css('display', $(selector).css('display') === 'block' ? 'none' : 'block');

            // set the hovering effect
            var t;
            $(selector + ', #seat_class_select').mouseout(function() {
                t = setTimeout('$(\'' + selector + '\').hide()', 1000);
            });

            $(selector + ', #seat_class_select').mouseover(function() {
                clearTimeout(t);
            });
        };

        this.updateSeatClass = function(elem) {
            var seat_class = 0;
            seat_class = $(elem).parent('li').find('label').html();

            $('#class_select div span').html(seat_class);
        };

        this._getCurrentTripTypeString = function() {
            switch (this.current_trip_type) {
                case 'roundtrip':
                    return 'Round Trip';
                case 'oneway':
                    return 'Oneway';
                case 'multi':
                    return 'Multi';
            }
        };

        this._showSegmentFields = function(keep_input_values) {
            var showFunction;
            var hideFunction;
            switch (this.show_hide_effect) {
                case 'slide':
                    showFunction = 'slideDown';
                    hideFunction = 'slideUp';
                    break;

                default:
                    showFunction = 'show';
                    hideFunction = 'hide';
            }

            for (var i = 0; i <= 5; i++) {
                var segment = $(this.form_selector + ' .seg' + i);
                var prevDatePicker = $(this.form_selector + ' .seg' + (i - 1) + ' .segment-datepicker');

                if (i < this.segments_to_show) {
                    segment[showFunction]();
                    segment.find('input, select')
                        .prop('disabled', false)
                        .prop('readonly', false)
                        .prop('tabindex', false);

                    var datePicker = segment.find('.segment-datepicker');

                    if (datePicker.val()) {
                        if (datePicker.val() < prevDatePicker.val()) {
                            datePicker.val('');
                        }
                    }

                    if (i === 4) {
                        $('.add-segment').hide();
                    }

                    if (this.current_trip_type === 'roundtrip' && i === 1) {
                        segment.find('.seg_from').val($('#seg0_to').val())
                            .change()
                            .prop('readonly', true)
                            .attr('tabindex', -1);
                        segment.find('.seg_to').val($('#seg0_from').val())
                            .change()
                            .prop('readonly', true)
                            .attr('tabindex', -1);
                    }
                } else {
                    segment[hideFunction]();
                    prevDatePicker.datepicker('setEndDate', Infinity);
                    segment.find('input, select').prop('disabled', true);
                    if (!keep_input_values) {
                        segment.find('input, select').attr('value', '').change();
                    }
                }
            }
        };

        this.toggleMoreOptions = function() {
            $('#more_options').slideToggle(200, function() {
                var arrow_direction = ($('#more_options').css('display') === 'block') ? 'up' : 'down';
                $('#more_options_arrow').attr('src', '/images/icon-arrow-' + arrow_direction + '.png');
            });
        };

        this.toggleCompactMinimalDisplay = function(force_open) {
            var parent = this;
            $('.minimal_display').each(function() {
                if ($(this).hasClass('buttons-add-remove') && parent.current_trip_type !== 'multi') {
                    return;
                }
                else if (force_open && $('.minimal_display').css('display') === 'block') {
                    return;
                }

                $(this).slideToggle(200, function() {
                    parent.minimal_display = $('.minimal_display').css('display') === 'none';

                    var toggle_text = $('#toggle_minimal_display_button span:eq(0)').html();
                    $('#toggle_minimal_display_button span:eq(0)').html(toggle_text === '+' ? '-' : '+');
                });
            });
        };

        this.submit = function() {

            // do the validation
            var errors = {
                field_ids: [],
                error_messages: [],
                passenger_error: false,
                infant_passenger_error: false
            };
            var num_pax = {
                'adults': 0,
                //'seniors' : 0,
                'children': 0,
                'infants': 0,
                'infants_lap': 0
            };

            var parent = this;

            // iterate through the visible fields only
            $(this.form_selector).find('input:visible, select:visible, [name^=num_]').each(function() {
                if ($(this).attr('name')) {
                    // all fields use the format seg#_<name>
                    var matches = $(this).attr('name').match(/seg(\d*)_(\w*)/);
                    if (matches) {
                        // check if this line has at least a value
                        var has_value = false;
                        $(parent.form_selector).find('[name^=seg' + matches[1] + '_]').each(function() {
                            if ($(this).val()) {
                                has_value = true;
                            }
                        });
                        var append, flight, type, date_type;
                        switch (matches[2]) {
                            case 'from':
                                if ($(this).val() === '') {
                                    append = '.';
                                    if (parent.current_trip_type === 'multi') {
                                        flight = $(this).attr('name').substring(3, 4);
                                        flight++;
                                        append = ' for flight No. ' + flight + '.';
                                    }
                                    errors.field_ids.push($(this).attr('name'));
                                    errors.error_messages.push('Please select a departure city' + append);
                                }

                                break;

                            case 'to':
                                append = '.';
                                if (parent.current_trip_type === 'multi') {
                                    flight = $(this).attr('name').substring(3, 4);
                                    flight++;
                                    append = ' for flight No. ' + flight + '.';
                                }

                                if ($(this).val() === '') {
                                    errors.field_ids.push($(this).attr('name'));
                                    errors.error_messages.push('Please select a destination city' + append);
                                }
                                else if ($(this).val() === $(parent.form_selector + ' [name=seg' + matches[1] + '_from]').val()) {
                                    errors.field_ids.push($(this).attr('name'));
                                    errors.error_messages.push('Your destination should be different from your departure' + append);
                                }

                                break;

                            case 'date':
                                append = '.';
                                if (parent.current_trip_type === 'multi') {
                                    flight = $(this).attr('name').substring(3, 4);
                                    flight++;
                                    append = ' for flight No. ' + flight + '.';
                                }

                                if ($(this).val() === '') {
                                    type = $(this).attr('name').substring(3, 4);
                                    date_type = type % 2 === 0 ? 'departure' : 'return';

                                    errors.field_ids.push($(this).attr('id'));
                                    errors.error_messages.push('Please select a ' + date_type + ' date' + append);
                                }
                                else if (!$(this).val().match(/(\d{4})-(\d{1,2})-(\d{2})/)) {
                                    type = $(this).attr('name').substring(3, 4);
                                    date_type = type % 2 === 0 ? 'departure' : 'return';

                                    errors.field_ids.push($(this).attr('name'));
                                    errors.error_messages.push('Invalid date format for the ' + date_type + ' date' + append + ' : ' + $(this).val());
                                }

                                break;

                        }
                    }
                    else if (matches = $(this).attr('name').match(/num_(adults|seniors|infants|infants_lap|children)$/)) {
                        num_pax[matches[1]] += parseInt($(this).val());
                    }
                    else if ($(this).attr('name').match('fare_alert_email')) // email validation
                    {
                        if ($(this).val() !== '') {
                            var email = $(this).val();
                            var filter = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
                            if (!filter.test(email)) {
                                errors.field_ids.push($(this).attr('id'));
                                errors.error_messages.push('Please enter a valid email');
                            }
                        }
                    }
                    else if (matches = $(this).attr('name').match(/currency_(\w*)/)) { // currency selected (input name is of type "currency_CAD")
                        if ($('input[name="' + matches[0] + '"]').prop('checked')) {
                            parent.currency_type = matches[1];
                        }
                    }
                }
            });

            // validate pax
            if (num_pax.adults + num_pax.children + num_pax.infants + num_pax.infants_lap === 0) {
                errors.field_ids.push('num_pax');
                errors.error_messages.push('Not enough passengers.');
            }
            else if (num_pax.adults + num_pax.children + num_pax.infants + num_pax.infants_lap > 9) {
                errors.field_ids.push('num_pax');
                errors.error_messages.push('A maximum of 9 passengers is allowed per booking.');
                errors.max_passenger_error = true;
            }
            else if (num_pax.infants + num_pax.infants_lap > num_pax.adults) {
                errors.field_ids.push('num_pax');
                errors.error_messages.push('The number of infants cannot exceed the number of adults.');
                errors.infant_passenger_error = true;
            }

            var error_count = 0;
            for (var k in errors.error_messages) {
                if (errors.error_messages[k]) {
                    error_count++;
                }
            }

            if (error_count) {
                //this._applyErrorMessages(errors);
                return;
            }

            // Submit
            $('#validation_errors').hide();
            window.location.href = $(this.form_selector).attr('action') + '?' + $.param(this._getFormValues(num_pax));
        };

        this._getFormValues = function(num_pax) {
            var $form = $(this.form_selector);
            var form_values = $form.serializeObject();
            delete form_values.trip; // form submission doesn't like this field name
            for (var field_name in form_values) {
                if (form_values.hasOwnProperty(field_name)) {
                    if (form_values[field_name] === '' || form_values[field_name] === 'default' || form_values[field_name] === 'all') {
                        delete form_values[field_name];
                    }

                    // deleting all still hidden inputs that arn't the airport code
                    if (field_name.indexOf('_code') === -1 &&
                        !$form.find('[name=' + field_name + ']').is(':visible,.include-hidden')
                    ) {
                        delete form_values[field_name];
                    }

                    // getting the currency type and submitting the type to the form
                    if (field_name.indexOf('currency_') >= 0 || field_name.indexOf('surfer_') >= 0) {
                        delete form_values[field_name];
                    }
                }
            }

            if (form_values.form_type) {
                delete form_values.form_type;
            }

            for (var i = 0; i < this.segments_to_show; i++) {
                if (form_values['seg' + i + '_from_code']) {
                    form_values['seg' + i + '_from'] = form_values['seg' + i + '_from_code'];
                    delete form_values['seg' + i + '_from_code'];
                }

                if (form_values['seg' + i + '_to_code']) {
                    form_values['seg' + i + '_to'] = form_values['seg' + i + '_to_code'];
                    delete form_values['seg' + i + '_to_code'];
                }
                // delete time of segments
                if ($('select[name=seg' + i + '_time]').find(':selected').index() === 0) {
                    delete form_values['seg' + i + '_time'];
                }
            }

            // number packages and send in form
            for (var pax in num_pax) {
                if (pax === 'adults') {
                    form_values.num_adults = num_pax[pax];
                }
                else if (pax === 'seniors') {
                    form_values.num_seniors = num_pax[pax];
                }
                else if (pax === 'children') {
                    form_values.num_children = num_pax[pax];
                }
                else if (pax === 'infants') {
                    form_values.num_infants = num_pax[pax];
                }
                else if (pax === 'infants_lap') {
                    form_values.num_infants_lap = num_pax[pax];
                }
            }

            return form_values;
        };

        this._applyErrorMessages = function(errors) {
            $(this.form_selector + ' .error').removeClass('error');
            $(this.form_selector + ' .error-label').remove();
            for (var x in errors.field_ids) {
                if (errors.field_ids.hasOwnProperty(x)) {
                    var field_id = errors.field_ids[x];
                    var error_label = '<div class="error-label error">';
                    if (field_id === 'num_pax') {
                        $('#passengers_select_label').hide();
                        $('#passengers_select').find('select').addClass('error');

                        if (this.form_view_type === 'compact') {
                            this.toggleCompactMinimalDisplay(true);
                        }
                    }
                    else {
                        $('#' + field_id).addClass('error');
                        $('[name=' + field_id + ']').addClass('error');

                    }
                    // apply error message
                    error_label += errors.error_messages[x] + '</div>';
                    // add using element name of ID not both
                    if ($('#' + field_id).attr('id') !== undefined) {
                        $('#' + field_id).parent().append(error_label);
                    }
                    else {
                        $('[name=' + field_id + ']').parent().append(error_label);
                    }
                    if (field_id === 'num_pax') {
                        $('#passengers_select_label').show();
                        $('#passengers_select_label').append(error_label);
                    }
                }
            }

            var error_string = '';
            if (this.form_view_type === 'compact') {
                if (errors.max_passenger_error) {
                    error_string = 'A maximum of 9 passengers is allowed per booking.';
                }
                else if (errors.infant_passenger_error) {
                    error_string = 'The number of infants cannot exceed the number of adults.';
                }
                else {
                    error_string = 'Please make sure that all the fields are filled';
                }
            }
            else {
                for (var y in errors.error_messages) {
                    if (errors.error_messages.hasOwnProperty(y)) {
                        error_string += errors.error_messages[y];
                        error_string += '<br>';
                    }
                }
            }
        };

        // Init
        this.resetDefault();
        this._mergeParams(params);

        var parent = this;
        // Init: Calendar
        parent.Calendar = new Calendar(parent.Calendar);

        $(parent.form_selector)
            .find('[rel=passengers_select] select')
            .change(function() {
                parent.updateNumPassengers();
            });

        $(parent.form_selector)
            .find('[rel=seat_class_select] input[type=radio]')
            .change(function() {
                parent.updateSeatClass(this);
            });

        $(parent.form_selector).find('option, select, input').keypress(function(e) {
            if (e.which === 13 && !parent.AirportAutocomplete.options_open) {
                parent.submit();
            }
        });

        // round-trip form auto-complete
        this._linkAutofillInput = function() {
            $(parent.form_selector).find('[name^=seg0]:visible').on('change keypress paste textInput blur', function(e) {
                // listening for cool events
                if (parent.current_trip_type === 'roundtrip' && (this.name.indexOf('from') > 0 || this.name.indexOf('to') > 0) && (this.name.indexOf('seg0') >= 0)) {
                    var action = this.name.split('_')[1];
                    var toChange = 'to';

                    if (action === 'to') {
                        toChange = 'from';
                    }
                    // correct until more than six digits
                    $('[name="seg1_' + toChange + '"]').prop('value', $(this).prop('value'));
                    $('[name="seg1_' + toChange + '_code"]').prop('value', $('[name=seg0_' + action + '_code]').prop('value'));
                }
            });
        };
        // link airport fields
        this._linkAutofillInput();

        // error handling
        $(parent.form_selector).find('input').on('keyup change', function() {
            var $this = $(this);
            var toggle = 'hide';
            var link = false;
            var toChange;
            if ($this.val() && ($this.parent().find($('.error-label')) || $this.hasClass('error'))) {
                $this.removeClass('error');
                toggle = 'hide';
            }
            if ($this.val() === '' || $this.val === ' ') {
                toggle = 'show';
            }
            // check round trip auto-complete
            if (parent.current_trip_type === 'roundtrip') {
                if (this.name) {
                    if (this.name.indexOf('seg1') < 0) {
                        var action = this.name.split('_')[1];
                        toChange = 'to';
                        link = true;

                        if (action === 'to') {
                            toChange = 'from';
                        }
                        if (this.name.indexOf('to') >= 0 || this.name.indexOf('from') >= 0) {
                            if ($('input[name="seg1_' + toChange + '"]').is(':visible') && $('input[name="seg1_' + toChange + '"]').prop('value').length > 0) {
                                $('input[name="seg1_' + toChange + '"]').removeClass('error');
                                $('input[name="seg1_' + toChange + '"]').parent().find($('.error-label'))[toggle]();
                            }
                        }
                    }
                }
            }
            $this.parent().find($('.error-label'))[toggle]();
            if (this.name.indexOf('to') >= 0 || this.name.indexOf('from') >= 0) {
                if (toggle === 'show') {
                    if (toChange !== '' && link) {
                        if ($this.parent().find($('.error-label')).text() !== '') {
                            $this.addClass('error');
                            $('input[name="seg1_' + toChange + '"]').addClass('error');
                            $('input[name="seg1_' + toChange + '"]').parent().find($('.error-label'))[toggle]();
                        }
                    }
                }
            }
        });

        // error handling for passengers
        $(parent.form_selector).find('select[name^=num]').on('change', function(handler) {
            var passengers_group = '#passengers_select';
            var passengers_label = '#passengers_select_label';

            // hide errors on change
            $(passengers_group).find('select').removeClass('error');
            $(passengers_label).hide();
        });
    };

    $(document).on('mouseout', '.ui-state-default', function() { // ui-state-default is in 'a' element
        $(document).find('td').removeClass('ui-state-to-over');
    });

    $(document).on('mouseover', '.ui-state-default', function() { // ui-state-default is in 'a' element

        $(document).find('td').removeClass('ui-state-over');
        if ($(this).hasClass('ui-state-hover')) {
            var currTd = $(this).parent();
            var currAe = currTd.find('a');
            var greatDivParent = currTd.parentsUntil('div').parent().parent();

            // find if there is a current date
            var selectTd = greatDivParent.find('.ui-datepicker-days-cell-over');//'.ui-datepicker-current-day');
            if (selectTd.length) { // it exists // date picked in this datepicker
                selectTd = greatDivParent.find('.ui-datepicker-current-day');
                if (selectTd.length) { // if selected from
                    return;
                }
            }
            else {
                return;
            }

            while (!currTd.hasClass('ui-datepicker-days-cell-over') && !currAe.hasClass('ui-state-active')) { // loop until we get to the current date
                if (!currTd.prev('td').length) {
                    if (currTd.hasClass('ui-datepicker-other-month') || currAe.text() === 1) {// check if it is the first of the month
                        currTd = currTd.parent().parent().parent().parent().prev('div').find('td').last(); // go to previous month in prev div
                    }
                    else {
                        currTd = currTd.parent().prev('tr').find('td').last();
                    }
                    if (!currTd.length) {
                        break; // reached the end of the list
                    }
                }
                else {
                    currTd = currTd.prev('td');
                }
                currAe = currTd.find('a');
                if (currAe.hasClass('ui-state-default') && !(currTd.hasClass('ui-datepicker-days-cell-over') || currTd.hasClass('ui-state-disabled') || currAe.hasClass('ui-state-active'))) {
                    currTd.addClass('ui-state-over');
                }
            }
        }
        return true;
    });

})();